import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="ltn__contact-address-area mb-90 mt-120">
      <div className="container">
        <div className="row">
          <ol>
          <li>
              <strong>Privacy Policy</strong>
              <ul>
                <li>
                  <strong>Introduction</strong>
                  <ul>
                    <li>
                    ZELLE LTD is committed to protecting your privacy. This policy 
                    outlines how we handle your personal information.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Collection of Information</strong>
                  <ul>
                    <li>
                    We collect information you provide and information automatically 
                    collected through your use of our services.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Use of Your Information</strong>
                  <ul>
                    <li>
                    Your information is used to provide services, process transactions, and 
                    for security purposes.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Sharing Your Information</strong>
                  <ul>
                    <li>
                    Information is only shared with third parties in compliance with this policy 
                    or as required by law.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Data Security</strong>
                  <ul>
                    <li>
                    We implement security measures to protect your information, though we 
                    cannot guarantee absolute security.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Your Rights</strong>
                  <ul>
                    <li>
                    You have rights to access, correct, or delete your personal information, 
                    subject to certain conditions.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Contact Us</strong>
                  <ul>
                    <li>
                    For any privacy-related questions or requests, contact us at &nbsp;
                    <a href="info@usee-360.com">info@usee-360.com</a>.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Changes to This Policy</strong>
                  <ul>
                    <li>
                    We may update our privacy policy and will communicate any changes 
                    through our website.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Account Deletion Policy</strong>
              <ul>
                <li>
                  <strong>Introduction</strong>
                  <ul>
                    <li>
                    At ZELLE LTD, we understand the importance of your privacy and
                    give you the option to delete your account and associated data
                    from our platform.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Deleting Your Account</strong>
                  <ul>
                    <li>
                      You can delete your account by accessing My Profile from
                      Trader or Customer Dashboard.
                    </li>
                    <li>
                      Upon receiving a deletion request, we will verify your
                      identity to prevent unauthorised deletions.
                    </li>
                    <li>
                      Once you delete your account, all your data will be
                      permanently removed from our platform. This includes your
                      personal information, transaction history, and any other
                      data associated with your account.
                    </li>
                    <li>
                      If you have any pending transactions, they will be
                      cancelled and your account will be deleted immediately.
                    </li>
                    <li>
                      You will not be able to recover your account or any
                      associated data once it has been deleted.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Data Retention</strong>
                  <ul>
                    <li>
                    We may retain certain data as required by law or for
                    legitimate business purposes after account deletion. This
                    includes transaction history, financial records, and any other
                    data that is necessary for compliance with legal obligations.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Effects of Deletion</strong>
                  <ul>
                    <li>
                    Deleting your account removes your access to our services and
                    erases your data from our active databases, subject to data
                    retention policies.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <strong>Cookie Policy </strong>
              <ul>
                <li>
                  <strong>Introduction</strong>
                  <ul>
                    <li>
                    This Cookie Policy outlines how Zelle Ltd uses cookies and similar 
                    technologies to recognize you when you visit our website at&nbsp;
                    <a href="https://usee360.com/">https://usee360.com/</a>{""}.&nbsp;It 
                    explains what these technologies are and why we use them, as well as your 
                    rights to control our use of them.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>What are cookies?</strong>
                  <ul>
                    <li>
                    Cookies are small data files placed on your device or computer that often 
                    include an anonymous unique identifier. Cookies are sent to your browser 
                    from a website and stored on your device.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Why do we use cookies?</strong>
                  <ul>
                    <li>
                    We use essential cookies to enable basic functions of our service, ensuring 
                    it operates smoothly and securely. These cookies are strictly necessary for 
                    you to navigate the site and use its features. Without these cookies, key 
                    aspects of our service wouldn't be available, affecting the user experience. 
                    We do not use cookies for analytics, preference storage, or advertising 
                    purposes.
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Types of cookies used</strong>
                  <ul>
                    <li>
                    Essential Cookies: Necessary for the website to function and cannot be 
                    switched off in our systems.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
